import { Dialog } from './dialog';
import { l } from '@js/utils/toolbox';


/**
 * Dialog class for displaying a dialog with accept or cancel options.
 * @class TooltipDialog
 * @param {string} title - The title of the dialog.
 * @param {string} text - The text content of the dialog.
 * @param {Function} callback - The callback function to execute on accepting the dialog.
 * @param {Object} options - Optional configuration options for the dialog. At the moment 'singleButton' is the only option
 * @param {string} cacheName - name to look into storage to see if the tooltip has been used
 * @param {string} readMore - if there is a readmore link
 */
export class TooltipDialog extends Dialog {
	constructor (title, text, callback, options = {}, cacheName, readMore = '') {
		const callbackWithCheckbox = () => {
			if (this.cacheName) {
				this.saveCachedTooltip();
			}
			callback();
		};

		if (readMore) {
			const readMoreContainer = document.createElement('div');
			readMoreContainer.classList.add('readMore--container');
			const anchorLink = document.createElement('a');
			anchorLink.href = readMore;
			anchorLink.title = l('dialog.tooltip.readMore');
			anchorLink.innerText = l('dialog.tooltip.readMore');
			anchorLink.classList.add('readMore--link');
			anchorLink.target = '_blank';
			readMoreContainer.append(anchorLink);
			options.additionalElements = [readMoreContainer];
		}

		super(title, text, callbackWithCheckbox, options);
		this.cacheName = cacheName;
	}

	saveCachedTooltip () {
		if (this.cacheName) {
			// TODO: For dismissing messages in the future and not show them again
		}
	}
}
